module.exports = __webpack_public_path__ + "static/pvp_icon-ecc54965070453890da75127aaa075d3.png";